/**
 * Reviews Slick
 */

$('#reviewsList').on('beforeChange', function(event, slick, direction){
    $('html, body').animate({
        scrollTop: $("#testimonials").offset().top - 50
    }, 1000);
});

$('#reviewsList').slick({
    infinite: false,
    slidesToShow: 1,
    arrows: false,
    dots: true,
    speed: 700,
    adaptiveHeight: true,
    centerMode: true,
    centerPadding: '30px'
});
